<template>
    <WizardPage
      v-if="shouldRender"
      :title="(index + 1) + '. ' + page.label"
      :can-navigate-back="canNavigateBack"
      :can-navigate-forward="canNavigateForward"
      :label-button-forward="labelButtonForward"
      :step="step">
    <Question
      v-for="question in questions"
      :key="question.key"
      :question="question"
      :answer="getAnswerForQuestion(question)"
      @update-answer="onUpdateAnswer" />
  </WizardPage>
</template>

<script>
import WizardPage from './WizardPage'
import WizardPageMixin from './../mixins/WizardPageMixin'
import Question from '@/components/questions/Question'
import BL from '@/bl/bl'

export default {
  name: 'WizardPageFrame',

  components: {
    WizardPage,
    Question
  },

  mixins: [
    WizardPageMixin
  ],

  props: {
    page: {
      type: Object,
      default: void 0,
      required: true
    },

    index: {
      type: Number,
      default: 0
    },

    answers: {
      type: Array,
      default: _ => []
    },

    numPages: {
      type: Number,
      default: void 0,
      required: true
    }
  },

  mounted () {
    if (this.shouldComputeProperties && (!this.questions || !this.questions.length)) {
      this.next()
    }
  },

  computed: {
    questions () {
      return this.shouldComputeProperties
        ? BL.getQuestionsToRenderForPage(this.page, this.answers)
        : []
    },

    mandatoryQuestionsWithoutAnswers () {
      return this.shouldComputeProperties
        ? BL.getMandatoryQuestionsWithoutAnswers(this.questions, this.answers)
        : []
    },

    isLastQuestionPage () {
      return this.shouldComputeProperties
        ? this.index === this.numPages - 1
        : false
    },

    labelButtonForward () {
      return this.shouldComputeProperties
        ? this.isLastQuestionPage ? 'Bewerbung definitiv einreichen' : void 0
        : void 0
    },

    canNavigateBack () {
      const hasRunningUploads = this.$store.getters['hasRunningUploads']
      return !hasRunningUploads
    },

    canNavigateForward () {
      const hasRunningUploads = this.$store.getters['hasRunningUploads']
      return (!this.mandatoryQuestionsWithoutAnswers || !this.mandatoryQuestionsWithoutAnswers.length) && !hasRunningUploads
    }
  },

  methods: {
    getAnswerForQuestion (question) {
      return BL.getAnswerForQuestion(question, this.answers)
    },

    onUpdateAnswer (value, question, answer) {
      BL.updateAnswerWithValue(question, answer, value, this.questions, this.answers)
    }
  }
}
</script>
